<template>
  <nav class="container py-40 border-t border-b border-light-gray-3">
    <!-- <h2 class="text-22 font-bold mb-24">{{ name }}</h2> -->
    <ul class="text-14 leading-1.2 column-2 lg:column-4">
      <li v-for="item in items" class="mb-8">
        <a :href="item.value" class="link link-supporting">
          <h3>{{ item.name }}</h3>
        </a>
      </li>
    </ul>
    <div v-if="! viewMore" class="lg:hidden text-center mt-16">
      <button class="text-14 link link-supporting" @click="viewMore = true">View More</button>
    </div>
  </nav>
</template>
<script>
export default {
  data () {
    return {
      ...jsonFromPage('#data-footer-menu'),
      viewMore: false,
    }
  },

  computed: {
    items () {
      return this.menuItems.filter(i => i.enabled).slice(0, (this.$mq.lg || this.viewMore) ? undefined : 8)
    }
  }
}
</script>
